import React from "react";
import { Flex, Alert, AlertIcon, Box, Button} from "@chakra-ui/react";
import { bookingFlowStore } from "../../store/BookingFlowStore";
import { appointmentTypesStore } from "../../store/AppointmentTypesStore";
import sanitizeHtml from "sanitize-html";
import { Buffer } from "buffer";

const Step5_Information: React.FC = () => {
  const appointmentType = bookingFlowStore.appointmentData.appointmentType;
  const instruction = appointmentTypesStore.selectedAptType?.appt_inst;

  const decodedMessage = appointmentType?.appt_que
    ? sanitizeHtml(
        Buffer.from(appointmentType.appt_que, "base64").toString("utf8")
      )
    : "";

    const isMessageEmpty = !decodedMessage?.trim() || decodedMessage === "<p></p>" || decodedMessage === "<br>";
const isInstructionEmpty = !instruction?.trim() || instruction === "<p></p>" || instruction === "<br>";
const selectedDoctor = bookingFlowStore.appointmentData.selectedDoctor;

if (isMessageEmpty && isInstructionEmpty) {
  bookingFlowStore.goToStep(6);
  bookingFlowStore.setActiveStep(6);
  return null;
} else if (!selectedDoctor) {
  bookingFlowStore.goToStep(6);
  bookingFlowStore.setActiveStep(6);
  return null;
}

  const handleBack = () => {
    bookingFlowStore.updateAppointmentData("appointmentType", null);
    bookingFlowStore.goToStep(4);
    bookingFlowStore.setActiveStep(3);
  };

  const handleNext = () => {
    bookingFlowStore.nextStep();
    bookingFlowStore.setActiveStep(bookingFlowStore.currentStep);
  };

  
  

  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center" maxWidth="500px">
      <Alert
        status="info"
        variant="subtle"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        p={10}
      >
        <AlertIcon boxSize="40px" mr={0} mb={2} />
        <p dangerouslySetInnerHTML={{ __html: decodedMessage }} />
      </Alert>

      <Box
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        fontWeight="bold"
        p={5}
      >
        <p dangerouslySetInnerHTML={{ __html: instruction }} />
      </Box>

      <Box display="flex" gap={2} p={5}>
        <Button
          color="#B92F2F"
          width="100px"
          border="2px"
          borderColor="#B92F2F"
          variant="outline"
          onClick={handleBack}
          _hover={{ bg: "#B92F2F", color: "#fff" , borderColor:"#B92F2F"}}
        >
          Back
        </Button>
        <Button
          bg="#B92F2F"
          color="#fff"
          width="100px"
          onClick={handleNext}
          _hover={{ bg: "red.700" }}
        >
          Next
        </Button>
      </Box>
    </Flex>
  );
};

export default Step5_Information;
